import { render } from "./QuestionFourScreen.vue?vue&type=template&id=1fdf940e&scoped=true&lang=html"
import script from "./QuestionFourScreen.vue?vue&type=script&lang=js"
export * from "./QuestionFourScreen.vue?vue&type=script&lang=js"

import "./QuestionFourScreen.vue?vue&type=style&index=0&id=1fdf940e&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/progressive/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdf940e"]])

export default __exports__